import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import cx from "classnames"
import { change, formValueSelector, reduxForm } from "redux-form";
import withStyles from "isomorphic-style-loader/withStyles";

import ProfileImageUpload from "./ProfileImageUpload/ProfileImageUpload";

import uploadProfileImage from '../../actions/siteadmin/uploadProfileImage';
import { loadAccount } from '../../actions/user/account';


import history from "../../history";
import messages from "../../locale/messages";
import { api, profilePhotouploadDir } from "../../config";
import defaultPhoneIcon from '/public/Icons/defaultPhoneIcon.svg'
import addBookingIcon from '/public/dashboard/addBookingIcon.svg';
import bt from '../commonStyle.css';
import s from './ProfileCard.css';


function ProfileCard(props) {
    const {
        change,
        uploadProfileImage,
        id,
        picture,
        loadAccount,
        userName,
        phoneNumber,
        phoneDialCode,
        profileLoader,
        intl: { formatMessage }
    } = props

    const success = async (fileName) => {
        await change('profileImage', fileName);
        await uploadProfileImage(id, fileName, picture)
        await loadAccount();
    }

    const redirectSearch = () => { history.push('/category?type=all') }
    return (
        <div className={s.profileCardContainer}>
            <div className={s.profileCardWrapper}>
                <ProfileImageUpload
                    isNoSubText={true}
                    defaultMessage={formatMessage(messages.chooseFile)}
                    postUrl={api.apiEndpoint + '/uploadProfileImage'}
                    loaderName={'profileLoader'}
                    loader={profileLoader}
                    imageSrc={picture ? api.apiEndpoint + profilePhotouploadDir + 'medium_' + picture : null}
                    fieldName={'profileImage'}
                    formName={'ProfileCard'}
                    handleDropzone={success}
                />
                <p className={s.profileCardTitle}><FormattedMessage {...messages.welcomeBack} /></p>
                <p className={s.profileCardName}>{userName}</p>
                <div className={cx(s.profilePhoneNumberSection, bt.commonSize14, bt.fontWeight400, bt.primaryColor, 'svgImg')}>
                    <img src={defaultPhoneIcon} alt="phoneIcon" width="16" height="16" />
                    <span>
                        <span className={bt.displayInlineBlock}>{phoneDialCode}</span>
                        <span className={bt.displayInlineBlock}>&nbsp;{phoneNumber}</span>
                    </span>
                </div>
            </div>
            <div onClick={redirectSearch} className={s.createBookingCard}>
                <div className={s.createBookingCardWrapper}>
                    <div className={s.createBookingCardIconContainer}>
                        <img src={addBookingIcon} alt="add" />
                    </div>
                    <FormattedMessage {...messages.createNewBooking} />
                </div>
            </div>
        </div>
    )
}
ProfileCard = reduxForm({
    form: 'ProfileCard',
    destroyOnUnmount: false,
})(ProfileCard)

const selector = formValueSelector('ProfileCard')

const mapState = (state) => ({
    userName: state?.userAccount?.data?.firstName,
    phoneDialCode: state?.userAccount?.data?.phoneDialCode,
    phoneNumber: state?.userAccount?.data?.phoneNumber,
    picture: state?.userAccount?.data?.picture,
    phoneCountryCode: state?.userAccount?.data?.phoneCountryCode,
    flagImage: state?.userAccount?.data?.flagImage,
    profileLoader: state?.loader?.profileLoader,
    id: state?.userAccount?.data?.userId,
    profileImage: selector(state, 'profileImage'),
});

const mapDispatch = {
    change,
    uploadProfileImage,
    loadAccount
};

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(ProfileCard)));
